import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8b97ea8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 导入Excel ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 审批提交 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 审批通过 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 审批驳回 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 确认上传 ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 大小小于500kb的Excel文件 ", -1))
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_16 = { class: "card-tools" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("搜索名称")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("搜索说明")
const _hoisted_22 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_23 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_24 = {
  class: "dialog-footer",
  style: {"margin-right":"30%"}
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_28 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_29 = {
  class: "dialog-footer",
  style: {"margin-right":"30%"}
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_31 = { class: "dialog-footer" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_33 = { class: "card-body table-responsive p-0" }
const _hoisted_34 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_35 = { ref: "tableTr" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "batchStatus" }, "状态", -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userCode" }, "工号", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "userName" }, "姓名", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "dutyDate" }, "日期", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "dutyHour" }, "时数", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "dutyStart" }, "起始时间", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "dutyEnd" }, "结束时间", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "dutyUse" }, "已使用", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "dutyInvalid" }, "已作废", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "dutyReason",
  class: "normal-width text-left"
}, "备注", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "batchCreateName" }, "创建批次信息", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "batchUseName" }, "使用批次信息", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyReason" }, "操作原因说明", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createName" }, "创建姓名", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "创建时间", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改姓名", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_55 = { key: 0 }
const _hoisted_56 = ["colspan"]
const _hoisted_57 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { key: 2 }
const _hoisted_61 = {
  key: 3,
  class: "table-btn-group"
}
const _hoisted_62 = { class: "btn-group" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "text-left" }
const _hoisted_66 = { key: 4 }
const _hoisted_67 = { key: 5 }
const _hoisted_68 = { key: 6 }
const _hoisted_69 = { key: 7 }
const _hoisted_70 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_71 = { class: "content-modal" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = {
  class: "col-lg-4",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":".6rem"} }, "值班日期", -1))
const _hoisted_75 = {
  class: "col-lg-4",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":".6rem"} }, "值班起始时间", -1))
const _hoisted_77 = {
  class: "col-lg-4",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":".6rem"} }, "值班结束时间", -1))

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_app_textarea = _resolveComponent("app-textarea")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/attendance/duty/balanceData/add') && _ctx.batchState === 40)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes mr-2",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.Auth('/attendance/duty/balanceData/formUpload') && _ctx.batchState === 30)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.dialogVisible = true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.Auth('/attendance/duty/balanceData/submissionBatch') && _ctx.batchState === 40)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    color: "#626aef",
                    onClick: _ctx.btnSubmissionBatch
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.Auth('/attendance/duty/balanceData/auditBatch') && _ctx.batchState === 50)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    type: "success",
                    onClick: _ctx.handleAgree
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.Auth('/attendance/duty/balanceData/auditBatch') && _ctx.batchState === 50)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 4,
                    type: "danger",
                    onClick: _ctx.handleReject
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.dialogVisible,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.dialogVisible) = $event)),
                title: "上传文件",
                width: "30%",
                "before-close": _ctx.handleClose,
                "destroy-on-close": "",
                center: ""
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    ref: "upload",
                    action: _ctx.uploadUrl,
                    "auto-upload": false,
                    accept: ".xlsx, .xls",
                    "show-file-list": true,
                    "before-upload": _ctx.beforeUpload,
                    "on-change": _ctx.onFileChange,
                    limit: 1,
                    style: {"text-align":"center"}
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    tip: _withCtx(() => [
                      _hoisted_13
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "ml-3",
                        type: "success",
                        onClick: _ctx.submitUpload
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["action", "before-upload", "on-change"])
                ]),
                _: 1
              }, 8, ["modelValue", "before-close"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.Auth('/attendance/duty/balanceData/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/attendance/duty/balanceData/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_17
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_18
                      ]),
                      _hoisted_19,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.searchFunction('user_code')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_20
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[6] || (_cache[6] = $event => (_ctx.searchFunction('duty_reason')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_21
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[9] || (_cache[9] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_ctx.Auth('/attendance/duty/balanceData/basicDisableAll'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[10] || (_cache[10] = $event => (_ctx.scenarioBox = true)),
                    type: "button",
                    class: "btn btn-themes"
                  }, " 一键禁用 "))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.scenarioBox,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.scenarioBox) = $event)),
                title: "一键禁用",
                width: "30%",
                "before-close": _ctx.handleClose,
                "destroy-on-close": "",
                center: ""
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_el_button, {
                      onClick: _ctx.scenarioBoxCancel,
                      style: {"padding":"8px 25px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[12] || (_cache[12] = $event => (_ctx.disableAll(_ctx.editModalItem.userCode))),
                      class: "btn-themes",
                      style: {"padding":"8px 25px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_app_input, {
                    label: "工号",
                    modelValue: _ctx.editModalItem.userCode,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.editModalItem.userCode) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue", "before-close"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_ctx.Auth('/attendance/duty/balanceData/modifyAllEmployee'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[14] || (_cache[14] = $event => (_ctx.scenarioBoxOther = true)),
                    type: "button",
                    class: "btn btn-themes"
                  }, " 一键修改工号 "))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.scenarioBoxOther,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.scenarioBoxOther) = $event)),
                title: "一键修改工号",
                width: "30%",
                "before-close": _ctx.handleClose,
                "destroy-on-close": "",
                center: ""
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_29, [
                    _createVNode(_component_el_button, {
                      onClick: _ctx.scenarioBoxOtherCancel,
                      style: {"padding":"8px 25px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[17] || (_cache[17] = $event => (_ctx.modifyAll(_ctx.editModalItem.userCode,_ctx.editModalItem.userNewCode))),
                      class: "btn-themes",
                      style: {"padding":"8px 25px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_app_input, {
                    label: "工号",
                    modelValue: _ctx.editModalItem.userCode,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.editModalItem.userCode) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_app_input, {
                    label: "新工号",
                    modelValue: _ctx.editModalItem.userNewCode,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.editModalItem.userNewCode) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue", "before-close"])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_ctx.Auth('/attendance/duty/balanceData/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_34, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_35, [
                      _hoisted_36,
                      _hoisted_37,
                      (_ctx.Auth('/attendance/duty/balanceData/mod'))
                        ? (_openBlock(), _createElementBlock("th", _hoisted_38, "操作"))
                        : _createCommentVNode("", true),
                      _hoisted_39,
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _hoisted_44,
                      _hoisted_45,
                      _hoisted_46,
                      _hoisted_47,
                      _hoisted_48,
                      _hoisted_49,
                      _hoisted_50,
                      _hoisted_51,
                      _hoisted_52,
                      _hoisted_53,
                      _hoisted_54
                    ], 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_57
                          ], 8, _hoisted_56)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.dutyId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        (parseInt(item.dutyStatus)===1)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: "hand",
                              onClick: $event => (_ctx.toggleStatus(item))
                            }, [
                              _createVNode(_component_svg_icon, {
                                name: "checkmark-circle-outline",
                                class: "hyper-text-themes"
                              })
                            ], 8, _hoisted_58))
                          : (parseInt(item.dutyStatus)===2)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: "hand",
                                onClick: $event => (_ctx.toggleStatus(item))
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: "close-circle-outline",
                                  class: "text-red"
                                })
                              ], 8, _hoisted_59))
                            : (_openBlock(), _createElementBlock("td", _hoisted_60, "未知")),
                        (_ctx.Auth('/attendance/duty/balanceData/mod'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                (_ctx.Auth('/attendance/duty/balanceData/mod'))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-themes",
                                      onClick: $event => (_ctx.modModalOpen(item))
                                    }, [
                                      _createVNode(_component_svg_icon, { name: "settings-outline" })
                                    ], 8, _hoisted_63))
                                  : _createCommentVNode("", true),
                                (_ctx.Auth('/attendance/duty/balanceData/del'))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-themes",
                                      onClick: $event => (_ctx.btnBasicDel(item))
                                    }, [
                                      _createVNode(_component_svg_icon, { name: "trash-outline" })
                                    ], 8, _hoisted_64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, _toDisplayString(item.userCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.userName), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.dutyDate)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.dutyHour), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getTime(item.dutyStart)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getTime(item.dutyEnd)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.dutyUse), 1),
                        _createElementVNode("td", null, _toDisplayString(item.dutyInvalid), 1),
                        _createElementVNode("td", _hoisted_65, _toDisplayString(item.dutyReason), 1),
                        _createElementVNode("td", null, _toDisplayString(item.batchCreateName), 1),
                        (this.$tools.isEmpty(item.batchUseName))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_66, "暂无"))
                          : _createCommentVNode("", true),
                        (!this.$tools.isEmpty(item.batchUseName))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_67, _toDisplayString(item.batchUseName), 1))
                          : _createCommentVNode("", true),
                        (this.$tools.isEmpty(item.modifyReason))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_68, "暂无"))
                          : _createCommentVNode("", true),
                        (!this.$tools.isEmpty(item.modifyReason))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(item.modifyReason), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, _toDisplayString(item.createName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyTime), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_71, [
      _createVNode(_component_app_alert, { ref: "delModal" }, null, 512),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: _ctx.editModalTitle,
        submitButtonName: _ctx.editModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editModalSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_72, [
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "工号",
              modelValue: _ctx.editModalItem.userCode,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.editModalItem.userCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "姓名",
              modelValue: _ctx.editModalItem.userName,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.editModalItem.userName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "时数",
              modelValue: _ctx.editModalItem.dutyHour,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.editModalItem.dutyHour) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.editModalItem.dutyDate,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.editModalItem.dutyDate) = $event)),
                type: "date",
                size: "large",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                shortcuts: _ctx.dateTimeShortcuts
              }, null, 8, ["modelValue", "shortcuts"])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.editModalItem.dutyStart,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.editModalItem.dutyStart) = $event)),
                type: "datetime",
                size: "large",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                shortcuts: _ctx.dateTimeShortcuts
              }, null, 8, ["modelValue", "shortcuts"])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.editModalItem.dutyEnd,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => ((_ctx.editModalItem.dutyEnd) = $event)),
                type: "datetime",
                size: "large",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                shortcuts: _ctx.dateTimeShortcuts
              }, null, 8, ["modelValue", "shortcuts"])
            ]),
            _createVNode(_component_app_textarea, {
              class: "col-lg-12",
              label: "备注",
              modelValue: _ctx.editModalItem.dutyReason,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((_ctx.editModalItem.dutyReason) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}